export const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';
export const FETCH_PROVIDERS_PROFILES_REQUEST = 'FETCH_PROVIDERS_PROFILES_REQUEST';
export const FETCH_PROVIDERS_PROFILES_SUCCESS = 'FETCH_PROVIDERS_PROFILES_SUCCESS';
export const FETCH_PROVIDERS_PROFILES_FAILURE = 'FETCH_PROVIDERS_PROFILES_FAILURE';
export const UPDATE_PROFILE_STATUS_REQUEST = 'UPDATE_PROFILE_STATUS_REQUEST';
export const UPDATE_PROFILE_STATUS_SUCCESS = 'UPDATE_PROFILE_STATUS_SUCCESS';
export const UPDATE_PROFILE_STATUS_FAILURE = 'UPDATE_PROFILE_STATUS_FAILURE';
export const UPDATE_PROFILE_IMAGE_REQUEST = 'UPDATE_PROFILE_IMAGE_REQUEST';
export const UPDATE_PROFILE_IMAGE_SUCCESS = 'UPDATE_PROFILE_IMAGE_SUCCESS';
export const UPDATE_PROFILE_IMAGE_FAILURE = 'UPDATE_PROFILE_IMAGE_FAILURE';